import { FormFieldExpression } from './form-field-expression.model';
import { FormFieldAction } from './form-field-action.model';
import { Form } from '../form-builder/form.model';
import { ConditionalLogicRuleOperator } from './rule-operator.model';
import { FormField } from '../form-builder/form-field.model';
import { FieldDefinition } from '../form-builder/field-definition.model';
import { FieldConditionalLogicService, FormFieldActionValue, TargetFieldDefaultAttributeValue } from '../../services/field-conditional-logic.service';
import { FieldConditionalLogicActionNameEnum, FieldConditionalLogicTargetFieldDefaultAttrs } from './enums';
import { FormFieldUtil } from '../../utility-classes/form-field.util';
import { MultipleFieldsMetadataFieldType } from '../form-builder/form-field-types';
import { FormBuilderService } from '../../services/form-builder.service';
import { FormTemplateInstancesFieldType, GridFieldType } from '../form-builder/form-field-types';

export class MultipleFieldsMetadataFieldInfo {
    public constructor(public multipleFieldsMetadataField: FormField, public fieldAlreadExisted: boolean = false) {
    }
}

export class CurrentRuleCondition {
    // Properties.
    public formTemplate: Form = null;

    public sourceFieldId: number = 0;
    public sourceFormField: FormField = null;

    public sourceFieldChildFieldId: number = 0; // Only used for grid source fields.
    public sourceFieldChildFieldName: string = ''; // Only used for grid source fields.
    //public sourceFieldChildField: FormField = null;
    public get sourceFieldChildField(): FormField {
        let childField: FormField = null;

        if (this.formTemplate != null) {
            let sourceField: FormField = this.formTemplate.formFields != null ? this.formTemplate.formFields.find(ff => ff.id == this.sourceFieldId) : null;

            if ((sourceField != null) && (sourceField.childFormFields != null)) {
                if ((this.sourceFieldChildFieldName != null) && (this.sourceFieldChildFieldName.trim() != '')) {
                    childField = sourceField.childFormFields.find(cff => cff.name == this.sourceFieldChildFieldName);
                } else if (this.sourceFieldChildFieldId > 0) {
                    childField = sourceField.childFormFields.find(cff => cff.id == this.sourceFieldChildFieldId);
                }
            }
        }

        return childField;
    }

    public comparisonOperator: string;
    public comparisonOperatorId: number = 0;

    public comparisonValue: string;

    // Constructor.
    public constructor(//private form: Form
    )
    {
    }

    // Static methods.
    public static createConditionFromRule(form: Form, metadataFauxFormFields: FormField[], rule: FormFieldExpression, availableOperators: ConditionalLogicRuleOperator[]): CurrentRuleCondition {
        let condition: CurrentRuleCondition = new CurrentRuleCondition();

        condition.sourceFieldId = rule.sourceFieldId;
        condition.sourceFormField = CurrentConditionalLogicRuleInfo.findFormFieldById(form, metadataFauxFormFields, rule.sourceFieldId);

        condition.sourceFieldChildFieldName = rule.sourceFieldChildFieldName;
        let sourceFormField: FormField = form.formFields != null ? form.formFields.find(ff => ff.id == rule.sourceFieldId) : null;
        if ((sourceFormField != null) && (rule.sourceFieldChildFieldName != null) && (rule.sourceFieldChildFieldName != '') && (sourceFormField.childFormFields != null)) {
            //condition.sourceFieldChildField = sourceFormField.childFormFields.find(cff => cff.name == rule.sourceFieldChildFieldName);
            let childField: FormField = sourceFormField.childFormFields.find(cff => cff.name == rule.sourceFieldChildFieldName);
            //if (condition.sourceFieldChildField != null)
            if (childField != null) {
                //condition.sourceFieldChildFieldId = condition.sourceFieldChildField.id;
                condition.sourceFieldChildFieldId = childField.id;
            }
        }

        let operator: ConditionalLogicRuleOperator = availableOperators.find(o => o.symbol == rule.operatorSymbol);
        condition.comparisonOperatorId = operator.id;
        condition.comparisonValue = rule.operandValue;

        return condition;
    }

    public clone(): CurrentRuleCondition {
        let myClone: CurrentRuleCondition = new CurrentRuleCondition();

        myClone.sourceFieldId = this.sourceFieldId;
        myClone.sourceFormField = this.sourceFormField;

        myClone.sourceFieldChildFieldId = this.sourceFieldChildFieldId;
        myClone.sourceFieldChildFieldName = this.sourceFieldChildFieldName;
        //myClone.sourceFieldChildField = this.sourceFieldChildField;

        myClone.comparisonOperatorId = this.comparisonOperatorId;
        myClone.comparisonOperator = this.comparisonOperator;

        myClone.comparisonValue = this.comparisonValue;

        return myClone;
    }
}

export class CurrentRuleAction {
    // Properties.
    public id: number;

    //public targetFieldId: number = 0;
    //public targetFormField: FormField;
    public targetFieldIds: number[] = [];
    public targetFormFields: FormField[] = [];

    public fetchingChildFormFields: boolean = false;
    public availableChildFormFields: FormField[] = [];
    public childFormFieldId: number = 0;
    public childFieldName: string = null;
    public filterOperator: string;

    public targetFieldDefaultAttributes: string = FieldConditionalLogicTargetFieldDefaultAttrs.None;

    public targetFieldAction: string = FieldConditionalLogicActionNameEnum.NoAction;

    public conditions: CurrentRuleCondition[] = [];

    public existingRule: FormFieldExpression = null; // Used to keep track of an existing rule.
    public existingRuleActionIndex: number = -1;

    public requiresOperandValue: boolean = true;

    // Constructor.
    public constructor(private form: Form,
        targetFieldIds: number[] = [],
        targetFieldAction: string = FieldConditionalLogicActionNameEnum.NoAction,
        targetFieldDefaultAttributes: string = FieldConditionalLogicTargetFieldDefaultAttrs.None)
    {
        //this.targetFieldId = targetFieldId;
        this.targetFieldIds = targetFieldIds;
        this.targetFieldDefaultAttributes = targetFieldDefaultAttributes;
        this.targetFieldAction = targetFieldAction;
    }

    public clone(): CurrentRuleAction {
        let myClone: CurrentRuleAction = new CurrentRuleAction(this.form);

        myClone.id = this.id;
        //myClone.targetFieldId = this.targetFieldId;
        //myClone.targetFormField = this.targetFormField;
        myClone.targetFieldIds = this.targetFieldIds;
        myClone.targetFormFields = this.targetFormFields;
        myClone.targetFieldDefaultAttributes = this.targetFieldDefaultAttributes;
        myClone.targetFieldAction = this.targetFieldAction;
        myClone.existingRuleActionIndex = this.existingRuleActionIndex;

        myClone.childFormFieldId = this.childFormFieldId;
        myClone.availableChildFormFields = this.availableChildFormFields;
        myClone.childFieldName = this.childFieldName;
        myClone.filterOperator = this.filterOperator;

        myClone.conditions = [];
        for (let index: number = 0; index < this.conditions.length; index++) {
            let condition: CurrentRuleCondition = this.conditions[index];
            let conditionClone: CurrentRuleCondition = condition.clone();
            myClone.conditions.push(conditionClone);
        }

        return myClone;
    }

    public setNoDefaultAttributesToNull(): void {
        if (this.targetFieldDefaultAttributes == FieldConditionalLogicTargetFieldDefaultAttrs.None)
            this.targetFieldDefaultAttributes = null;
    }
    public createMultipleFieldsMetadataFieldIfApplicable(): MultipleFieldsMetadataFieldInfo { //FormField {
        //let multipleFieldsMetadataField: FormField = null;
        let multipleFieldsMetadataFieldInfo: MultipleFieldsMetadataFieldInfo = null;

        // Note:  if multiple target fields are selected, we have to replace the fields with a single, multiple fields metadata field.
        if (this.targetFormFields.length > 1) {
            // Build the multiple field Id values property.
            let targetFieldIds: string = '';
            for (let index: number = 0; index < this.targetFormFields.length; index++) {
                let targetField: FormField = this.targetFormFields[index];
                if (index > 0)
                    targetFieldIds += ',';
                targetFieldIds += targetField.id;
            }

            // Per VNEXT-1387, first see if there is an existing field that represents the specified target fields.
            let multipleFieldsMetadataField: FormField = this.form.formFields.find(ff => (ff.fieldDefinitionClassName == MultipleFieldsMetadataFieldType) && (ff.multipleFieldIds == targetFieldIds));

            if (multipleFieldsMetadataField == null) {
                // Create a new metadata field that represents multiple fields.
                multipleFieldsMetadataField = new FormField();
                multipleFieldsMetadataField.fieldDefinitionClassName = MultipleFieldsMetadataFieldType;

                multipleFieldsMetadataField.multipleFieldIds = targetFieldIds;

                // Set the metadata field as my target field.
                this.targetFieldIds = [multipleFieldsMetadataField.id]; // Note:  this assignment is meaningless as the field Id will be zero at this point.
                this.targetFormFields = [multipleFieldsMetadataField];

                multipleFieldsMetadataFieldInfo = new MultipleFieldsMetadataFieldInfo(multipleFieldsMetadataField, false);
            } else {
                multipleFieldsMetadataFieldInfo = new MultipleFieldsMetadataFieldInfo(multipleFieldsMetadataField, true);
            }
        }

        //return multipleFieldsMetadataField;
        return multipleFieldsMetadataFieldInfo;
    }
    public expandMultipleFieldsMetadataFieldIfApplicable(form: Form): void {
        if ((this.targetFormFields != null) && (this.targetFormFields.length == 1) && (this.targetFormFields[0].fieldDefinitionClassName == MultipleFieldsMetadataFieldType)) {
            let formFieldIdTextValues: string[] = this.targetFormFields[0].multipleFieldIds.split(',');
            let formFields: FormField[] = [];
            let formFieldIds: number[] = [];

            for (let index: number = 0; index < formFieldIdTextValues.length; index++) {
                let formFieldId: number = parseInt(formFieldIdTextValues[index]);
                if (!isNaN(formFieldId)) {
                    let formField: FormField = form.formFields.find(ff => ff.id == formFieldId);
                    if (formField != null) {
                        formFields.push(formField);
                        formFieldIds.push(formField.id);
                    }
                }
            }

            this.targetFormFields = formFields;
            this.targetFieldIds = formFieldIds;
        }
    }

    public static createFromSingleActionRule(form: Form, metadataFauxFormFields: FormField[], singleActionRule: FormFieldExpression, availableOperators: ConditionalLogicRuleOperator[], formBuilderService: FormBuilderService): CurrentRuleAction {
        let singleAction: FormFieldAction = singleActionRule.actions[0];

        let targetFieldIds: number[] = [singleAction.targetFieldId];
        //let ruleAction: CurrentRuleAction = new CurrentRuleAction(singleAction.targetFieldId, singleAction.actionName, singleAction.targetFormFieldDefaultAttributes);
        let ruleAction: CurrentRuleAction = new CurrentRuleAction(form, targetFieldIds, singleAction.actionName, singleAction.targetFormFieldDefaultAttributes);
        //ruleAction.targetFormField = CurrentConditionalLogicRuleInfo.findFormFieldById(form, metadataFauxFormFields, singleAction.targetFieldId);
        ruleAction.targetFormFields = CurrentConditionalLogicRuleInfo.findFormFieldsById(form, metadataFauxFormFields, [singleAction.targetFieldId]);
        ruleAction.childFieldName = singleAction.childFieldName;
        ruleAction.filterOperator = singleAction.filterOperator;

        if (ruleAction.targetFormFields.length == 1) {
            let targetFormField: FormField = ruleAction.targetFormFields[0];

            CurrentRuleAction.loadAdditionalTargetFieldAttributes(ruleAction, targetFormField, formBuilderService);
        }

        let condition: CurrentRuleCondition = new CurrentRuleCondition();
        condition.sourceFieldId = singleActionRule.sourceFieldId;
        condition.sourceFormField = CurrentConditionalLogicRuleInfo.findFormFieldById(form, metadataFauxFormFields, singleActionRule.sourceFieldId);

        condition.sourceFieldChildFieldName = singleActionRule.sourceFieldChildFieldName;
        if ((condition.sourceFieldChildFieldName != null) && (condition.sourceFieldChildFieldName.trim() != '')) {
            //condition.sourceFieldChildField = (condition.sourceFormField != null) && (condition.sourceFormField.childFormFields != null) ? condition.sourceFormField.childFormFields.find(cff => cff.name == condition.sourceFieldChildFieldName) : null;
            let childField: FormField = (condition.sourceFormField != null) && (condition.sourceFormField.childFormFields != null) ? condition.sourceFormField.childFormFields.find(cff => cff.name == condition.sourceFieldChildFieldName) : null;
            //if (condition.sourceFieldChildField != null)
                //condition.sourceFieldChildFieldId = condition.sourceFieldChildField.id;
            if (childField != null)
                condition.sourceFieldChildFieldId = childField.id;
        }

        let operator: ConditionalLogicRuleOperator = availableOperators.find(o => o.symbol == singleActionRule.operatorSymbol);
        condition.comparisonOperatorId = operator.id;
        condition.comparisonOperator = singleActionRule.operatorSymbol;

        condition.comparisonValue = singleActionRule.operandValue;

        ruleAction.conditions = [condition];

        return ruleAction;
    }

    // Methods.
    public editExistingRule(form: Form, existingRule: FormFieldExpression, availableOperators: ConditionalLogicRuleOperator[]): boolean {
        this.existingRule = existingRule;

        if ((existingRule.actions != null) && (existingRule.actions.length > 0)) {
            let action: FormFieldAction = existingRule.actions[0];
            //this.targetFieldId = action.targetFieldId;
            this.targetFieldIds = [action.targetFieldId];
            //this.targetFormField = CurrentConditionalLogicRuleInfo.findFormFieldByName(form, action.targetFieldName);
            let targetField: FormField = CurrentConditionalLogicRuleInfo.findFormFieldByName(form, action.targetFieldName);
            this.targetFormFields = [targetField];
            this.targetFieldAction = action.actionName;
        }

        let condition: CurrentRuleCondition = new CurrentRuleCondition();
        condition.sourceFieldId = existingRule.sourceFieldId;
        condition.sourceFormField = CurrentConditionalLogicRuleInfo.findFormFieldByName(form, existingRule.sourceFieldName);
        let comparisonOperator: ConditionalLogicRuleOperator = availableOperators.find(o => o.symbol == existingRule.operatorSymbol);
        condition.comparisonOperatorId = comparisonOperator.id;
        condition.comparisonValue = existingRule.operandValue;
        this.conditions = [condition];

        return true;
    }
    public editExistingRuleAction(form: Form, existingRuleAction: CurrentRuleAction, availableOperators: ConditionalLogicRuleOperator[], formBuilderService: FormBuilderService): boolean {
        //this.targetFieldId = existingRuleAction.targetFieldId;
        //this.targetFormField = existingRuleAction.targetFormField;
        this.targetFieldIds = existingRuleAction.targetFieldIds;
        this.targetFormFields = existingRuleAction.targetFormFields;
        this.childFieldName = existingRuleAction.childFieldName;
        if ((this.childFieldName != null) && (this.childFieldName.trim() != '')) {
            if (this.targetFormFields.length == 1) {
                let loneTargetField: FormField = this.targetFormFields[0];

                if ((loneTargetField.fieldDefinitionClassName == GridFieldType) && (loneTargetField.childFormFields != null)) {
                    let childFormField: FormField = loneTargetField.childFormFields.find(cff => cff.name == this.childFieldName);
                    if (childFormField != null)
                        this.childFormFieldId = childFormField.id;
                } else if (loneTargetField.fieldDefinitionClassName == FormTemplateInstancesFieldType) {
                    // Note:  this condition would require a request to the server, something this logic is not presently handling.
                    //
                    //        The field conditional logic should handle getting the necessary information from the server.
                }
            }
        }
        this.filterOperator = existingRuleAction.filterOperator;

        if (this.targetFormFields.length == 1) {
            let targetFormField: FormField = this.targetFormFields[0];

            CurrentRuleAction.loadAdditionalTargetFieldAttributes(this, targetFormField, formBuilderService);
        }

        this.targetFieldDefaultAttributes = existingRuleAction.targetFieldDefaultAttributes;
        if ((this.targetFieldDefaultAttributes == null) || (this.targetFieldDefaultAttributes == ''))
            this.targetFieldDefaultAttributes = FieldConditionalLogicTargetFieldDefaultAttrs.None;

        this.targetFieldAction = existingRuleAction.targetFieldAction;

        this.conditions = existingRuleAction.conditions;
        if (this.conditions.length > 0) {
            for (let index: number = 0; index < this.conditions.length; index++) {
                let condition: CurrentRuleCondition = this.conditions[index];

                if ((condition.sourceFieldChildFieldName != null) && (condition.sourceFieldChildFieldName.trim() != null)) {
                    //condition.sourceFieldChildField = (condition.sourceFormField != null) && (condition.sourceFormField.childFormFields != null) ? condition.sourceFormField.childFormFields.find(cff => cff.name == condition.sourceFieldChildFieldName) : null;
                    let childField: FormField = (condition.sourceFormField != null) && (condition.sourceFormField.childFormFields != null) ? condition.sourceFormField.childFormFields.find(cff => cff.name == condition.sourceFieldChildFieldName) : null;
                    //if (condition.sourceFieldChildField != null)
                    //    condition.sourceFieldChildFieldId = condition.sourceFieldChildField.id;
                    if (childField != null)
                        condition.sourceFieldChildFieldId = childField.id;
                }
            }
        }

        return true;
    }
    private static loadAdditionalTargetFieldAttributes(currentRuleAction: CurrentRuleAction, targetFormField: FormField, formBuilderService: FormBuilderService): void {
        if ((targetFormField.fieldDefinitionClassName == FormTemplateInstancesFieldType) && (targetFormField.formTemplateId != null)) {
            formBuilderService.get(targetFormField.formTemplateId).then(formTemplate => {
                if (formTemplate.formFields != null) {
                    currentRuleAction.availableChildFormFields = formTemplate.formFields;
                    let childFormField: FormField = currentRuleAction.availableChildFormFields.find(ff => ff.name == currentRuleAction.childFieldName);
                    if (childFormField != null) {
                        currentRuleAction.childFormFieldId = childFormField.id;
                    }
                }
            });
        }

    }
    public copyToExistingRuleAndNewRulesAsNeeded(form: Form, metadataFauxFormFields: FormField[], formFieldExpression: FormFieldExpression, availableOperators: ConditionalLogicRuleOperator[], numExistingConditionalLogicRules: number): FormFieldExpression[] {
        let newRules: FormFieldExpression[] = [];

        for (let conditionIndex: number = 0; conditionIndex < this.conditions.length; conditionIndex++) {
            let condition: CurrentRuleCondition = this.conditions[conditionIndex];

            let currentExpression: FormFieldExpression = (conditionIndex == 0) && (formFieldExpression != null) ? formFieldExpression : new FormFieldExpression();

            this.copyConditionInfo(form, metadataFauxFormFields, currentExpression, condition, availableOperators);
            let formFieldAction: FormFieldAction = new FormFieldAction();

            let multipleFieldsMetadataFieldInfo: MultipleFieldsMetadataFieldInfo = this.createMultipleFieldsMetadataFieldIfApplicable();
            //let targetFormField: FormField = this.targetFormFields[0];
            let targetFormField: FormField = multipleFieldsMetadataFieldInfo != null ? multipleFieldsMetadataFieldInfo.multipleFieldsMetadataField : this.targetFormFields[0];

            formFieldAction.targetFieldId = targetFormField.id;
            formFieldAction.targetFieldName = targetFormField.name;
            formFieldAction.childFieldName = this.childFieldName;
            formFieldAction.filterOperator = this.filterOperator;
            formFieldAction.targetFormFieldDefaultAttributes = this.targetFieldDefaultAttributes;
            formFieldAction.actionName = this.targetFieldAction;
            currentExpression.actions = [formFieldAction];

            if ((conditionIndex > 0) || (formFieldExpression == null))
                newRules.push(currentExpression);
        }

        // Reset my data to default values.
        this.resetToDefaults();

        return newRules;
    }
    public packageRuleAndResetToDefaults(form: Form, metadataFauxFormFields: FormField[], availableOperators: ConditionalLogicRuleOperator[], numExistingConditionalLogicRules: number): FormFieldExpression[] {
        let packagedFieldExprs: FormFieldExpression[] = [];

        //if ((this.targetFieldId != 0) && (this.targetFieldAction != FieldConditionalLogicActionNameEnum.NoAction) && this.RuleConditionsValid) {
        if ((this.targetFieldIds.length != 0) && (this.targetFieldAction != FieldConditionalLogicActionNameEnum.NoAction) && this.RuleConditionsValid) {
            for (let index: number = 0; index < this.conditions.length; index++) {
                let condition: CurrentRuleCondition = this.conditions[index];

                let fieldExpr: FormFieldExpression = new FormFieldExpression();
                this.copyConditionInfo(form, metadataFauxFormFields, fieldExpr, condition, availableOperators);

                this.copyBasicRuleInfo(fieldExpr, availableOperators);

                packagedFieldExprs.push(fieldExpr);
            }
        }

        // Reset my data to default values.
        this.resetToDefaults();

        return packagedFieldExprs;
    }
    public get RuleConditionsValid(): boolean {
        let valid: boolean = false;

        if (this.conditions.length > 0) {
            valid = true; // For the moment, but we'll continue checking.

            for (let index: number = 0; index < this.conditions.length; index++) {
                let ruleCondition: CurrentRuleCondition = this.conditions[index];

                // First check to see if we have a source field and a valid operator.
                if ((ruleCondition.sourceFormField == null) || (ruleCondition.comparisonOperatorId == 0)) {
                    // If this operator requires a value, check to see if any value has been entered.
                    if (this.requiresOperandValue) {
                        if ((ruleCondition.comparisonValue == null) || (ruleCondition.comparisonValue.trim() == '')) {
                            valid = false;
                            break;
                        }
                    }
                }
            }
        }

        return valid;
    }

    // Helper methods.
    private copyBasicRuleInfo(formFieldExpression: FormFieldExpression, availableOperators: ConditionalLogicRuleOperator[]): void {
        let fieldAction: FormFieldAction = new FormFieldAction();
        let targetFormField: FormField = this.targetFormFields[0];
        //fieldAction.targetFieldId = this.targetFieldId;
        //fieldAction.targetFieldName = this.targetFormField.name;
        fieldAction.targetFieldId = targetFormField.id;
        fieldAction.targetFieldName = targetFormField.name;
        fieldAction.actionName = this.targetFieldAction;
        formFieldExpression.actions = [fieldAction];
    }
    private copyConditionInfo(form: Form, metadataFauxFormFields: FormField[], fieldExpr: FormFieldExpression, condition: CurrentRuleCondition, availableOperators: ConditionalLogicRuleOperator[]): void {
        fieldExpr.sourceFieldId = condition.sourceFieldId;
        let sourceFormField: FormField = CurrentConditionalLogicRuleInfo.findFormFieldById(form, metadataFauxFormFields, fieldExpr.sourceFieldId);
        fieldExpr.sourceFieldName = sourceFormField.name;

        fieldExpr.sourceFieldChildFieldName = condition.sourceFieldChildFieldName;

        let operatorInfo: ConditionalLogicRuleOperator = availableOperators.find(op => op.id == condition.comparisonOperatorId);
        fieldExpr.operandValue = operatorInfo.name;
        fieldExpr.operatorSymbol = operatorInfo.symbol;

        fieldExpr.operandValue = condition.comparisonValue;
    }
    private processConditions(formFieldExpression: FormFieldExpression): void {
        // Note: this method is presently a NOOP by design.
    }

    public resetToDefaults(): void {
        this.targetFieldIds = []
        this.targetFormFields = [];

        this.fetchingChildFormFields = false;
        this.availableChildFormFields = [];
        this.childFormFieldId = 0;
        this.childFieldName = null;
        this.filterOperator = null;

        //this.targetFieldDefaultAttributes = FieldConditionalLogicTargetFieldDefaultAttrs.None;

        this.targetFieldAction = FieldConditionalLogicActionNameEnum.NoAction;

        this.conditions = [];

        this.existingRule = null;
        this.existingRuleActionIndex = -1;

        this.requiresOperandValue = true;
    }
}

export class CurrentConditionalLogicRuleInfo {
    public sourceFieldId: number = 0;
    public sourceFormField: FormField;

    public comparisonOperatorId: number = 0;

    public comparisonValue: string;

    public currentRuleActions: CurrentRuleAction[] = [];

    public existingRule: FormFieldExpression = null;

    public get RuleActionsValid(): boolean {
        let valid: boolean = false;

        if (this.currentRuleActions.length > 0) {
            valid = true; // For the moment, but we'll continue checking.

            for (let index: number = 0; index < this.currentRuleActions.length; index++) {
                let ruleAction: CurrentRuleAction = this.currentRuleActions[index];

                //if ((ruleAction.targetFormField == null) || (ruleAction.targetFieldAction == FieldConditionalLogicActionNameEnum.NoAction)) {
                if ((ruleAction.targetFormFields.length == 0) || (ruleAction.targetFieldAction == FieldConditionalLogicActionNameEnum.NoAction)) {
                    valid = false;
                    break;
                }
            }
        }

        return valid;
    }

    public packageRuleAndResetToDefaults(availableOperators: ConditionalLogicRuleOperator[], numExistingConditionalLogicRules: number): FormFieldExpression {
        let formFieldExpression: FormFieldExpression = new FormFieldExpression();

        // Package the current rule.
        this.copyBasicRuleInfo(formFieldExpression, availableOperators);
        formFieldExpression.expressionOrder = numExistingConditionalLogicRules;

        // Process actions.
        this.processActions(formFieldExpression);

        // Reset the current rule to default values.
        this.resetToDefaults()

        // Return the packaged rule.
        return formFieldExpression;
    }

    public copyToExistingRuleAndResetToDefaults(formFieldExpression: FormFieldExpression, availableOperators: ConditionalLogicRuleOperator[], numExistingConditionalLogicRules: number): void {
        // Package the current rule.
        this.copyBasicRuleInfo(formFieldExpression, availableOperators);

        // Process actions.
        this.processActions(formFieldExpression);

        // Reset the current rule to default values.
        this.resetToDefaults()
    }

    public editExistingRule(form: Form, existingRule: FormFieldExpression, availableOperators: ConditionalLogicRuleOperator[]): boolean {
        this.existingRule = existingRule;

        let sourceField: FormField = CurrentConditionalLogicRuleInfo.findFormFieldByName(form, existingRule.sourceFieldName);
        this.sourceFieldId = sourceField.id;
        this.sourceFormField = sourceField;

        let operatorInfo: ConditionalLogicRuleOperator = availableOperators.find(op => op.symbol == existingRule.operatorSymbol);
        this.comparisonOperatorId = operatorInfo.id;

        this.comparisonValue = existingRule.operandValue;

        this.currentRuleActions = [];
        if (existingRule.actions != null) {
            for (let index: number = 0; index < existingRule.actions.length; index++) {
                let formFieldAction: FormFieldAction = existingRule.actions[index];

                let ruleAction: CurrentRuleAction = new CurrentRuleAction(form);

                let targetField: FormField = CurrentConditionalLogicRuleInfo.findFormFieldByName(form, formFieldAction.targetFieldName);
                //ruleAction.targetFieldId = targetField.id;
                //ruleAction.targetFormField = targetField;
                ruleAction.targetFieldIds = [targetField.id];
                ruleAction.targetFormFields = [targetField];

                ruleAction.targetFieldDefaultAttributes = formFieldAction.targetFormFieldDefaultAttributes;

                ruleAction.targetFieldAction = CurrentConditionalLogicRuleInfo.modelActionValueToDisplayValues(formFieldAction.actionName);

                this.currentRuleActions.push(ruleAction);
            }
        }

        return true;
    }

    public static findFormFieldByName(form: Form, fieldName: string): FormField {
        let formField: FormField = form.formFields.find(ff => (ff.name == fieldName) && (!ff.isDeleted));
        return formField;
    }
    public static findFormFieldById(form: Form, metadataFauxFormFields: FormField[], fieldId: number): FormField {
        let formField: FormField = null;
        if (fieldId > 0) {
            // This is an ordinary form field.
            formField = form.formFields.find(ff => ff.id == fieldId);
        } else {
            // This is a metadata faux form field.
            formField = metadataFauxFormFields.find(ff => ff.id == fieldId);
        }

        if (formField == null)
            throw `findFormFieldById():  cannot find a form field with id value ${fieldId}.`

        return formField;
    }
    public static findFormFieldsById(form: Form, metadataFauxFormFields: FormField[], fieldIds: number[]): FormField[] {
        let formFields: FormField[] = [];

        for (let index: number = 0; index < fieldIds.length; index++) {
            let fieldId: number = fieldIds[index];
            let formField: FormField = CurrentConditionalLogicRuleInfo.findFormFieldById(form, metadataFauxFormFields, fieldId);
            if (formField != null)
                formFields.push(formField);
        }

        return formFields;
    }
    public static filterFormFieldsExceptField(form: Form, fieldName: string): FormField[] {
        let formFields: FormField[] = form.formFields.filter(ff => (ff.name != fieldName) && (!ff.isDeleted));
        return formFields;
    }

    // Helper methods.
    private copyBasicRuleInfo(formFieldExpression: FormFieldExpression, availableOperators: ConditionalLogicRuleOperator[]): void {
        formFieldExpression.sourceFieldName = this.sourceFormField.name;
        formFieldExpression.sourceFieldId = 0; // Will be assigned by the server.

        let operatorInfo: ConditionalLogicRuleOperator = availableOperators.find(op => op.id == this.comparisonOperatorId);
        formFieldExpression.operandValue = operatorInfo.name;
        formFieldExpression.operatorSymbol = operatorInfo.symbol;

        formFieldExpression.operandValue = this.comparisonValue;
    }

    private processActions(formFieldExpression: FormFieldExpression): void {
        formFieldExpression.actions = [];
        for (let index: number = 0; index < this.currentRuleActions.length; index++) {
            let ruleAction: CurrentRuleAction = this.currentRuleActions[index];

            let formFieldAction: FormFieldAction = new FormFieldAction();
            let targetFormField: FormField = ruleAction.targetFormFields[0];
            //formFieldAction.targetFieldName = ruleAction.targetFormField.name;
            formFieldAction.targetFieldName = targetFormField.name;
            formFieldAction.targetFieldId = 0; // Will be assigned by the server.

            formFieldAction.actionName = CurrentConditionalLogicRuleInfo.displayFieldActionToModelValue(ruleAction.targetFieldAction);

            formFieldAction.actionOrder = index;

            formFieldExpression.actions.push(formFieldAction);
        }
    }

    private resetToDefaults(): void {
        this.sourceFieldId = 0;
        this.sourceFormField = null;

        this.comparisonOperatorId = 0;

        this.comparisonValue = '';

        this.currentRuleActions = [];

        this.existingRule = null;
    }

    private static displayFieldActionToModelValue(displayFieldAction: string): string {
        let modelActionValue: string = displayFieldAction.replace(/, /g, '|');
        return modelActionValue;
    }
    private static modelActionValueToDisplayValues(modelActionValue: string): string {
        let displayActionValue: string = modelActionValue.replace(/\|/g, ', ');
        return displayActionValue;
    }
}

export interface IRulesByTargetFieldIdAndAction {
    [targetIdAndActionKey: string]: CurrentRuleAction;
}

export class AllCurrentRuleActions {
    // Instance data.
    private ruleActions: CurrentRuleAction[] = [];
    private fieldConditionalLogicService: FieldConditionalLogicService = null;

    // Constructor.
    public constructor(fieldConditionalLogicService: FieldConditionalLogicService) {
        this.fieldConditionalLogicService = fieldConditionalLogicService;
    }

    public setRuleActions(ruleActions: CurrentRuleAction[]): void {
        this.ruleActions = ruleActions;
        this.sortByTargetFieldAndActionPrecedence();
    }
    public getRuleActions(): CurrentRuleAction[] {
        return this.ruleActions;
    }
    public removeAllRuleActions(): void {
        this.ruleActions = [];
    }

    public addRuleAction(ruleAction: CurrentRuleAction): void {
        this.ruleActions.push(ruleAction);
        this.sortByTargetFieldAndActionPrecedence();
    }
    public getExistingRuleIndex(existingRule: CurrentRuleAction): number {
        let ruleIndex: number = 0;
        while ((this.ruleActions[ruleIndex] != existingRule) && (ruleIndex < this.ruleActions.length))
            ruleIndex++;

        if (this.ruleActions[ruleIndex] != existingRule)
            ruleIndex = -1;

        return ruleIndex;
    }
    public replaceRuleAction(indexOfRuleToReplace: number, ruleAction: CurrentRuleAction): boolean {
        let success: boolean = false;

        if (indexOfRuleToReplace < this.ruleActions.length) {
            this.ruleActions.splice(indexOfRuleToReplace, 1, ruleAction);
            success = true;
        }

        this.sortByTargetFieldAndActionPrecedence();

        return success;
    }
    public removeRuleAction(ruleAction: CurrentRuleAction): boolean {
        let numActions: number = this.ruleActions.length;
        this.ruleActions = this.ruleActions.filter(ra => ra != ruleAction);

        this.sortByTargetFieldAndActionPrecedence();

        return numActions != this.ruleActions.length;
    }

    // Methods.
    public sortByTargetFieldAndActionPrecedence(): void {
        this.ruleActions.sort(this.doSortByTargetFieldAndActionPrecedence);
    }

    public convertToFormFieldExpressions(form: Form, metadataFauxFormFields: FormField[], availableOperators: ConditionalLogicRuleOperator[]): FormFieldExpression[] {
        let existingRulesCopy: FormFieldExpression[] = (form.conditionalLogicRules != null) && (form.conditionalLogicRules.length > 0) ? form.conditionalLogicRules.slice() : []; // Copy all existing rules.

        let convertedRules: FormFieldExpression[] = [];

        for (let ruleIndex: number = 0; ruleIndex < this.ruleActions.length; ruleIndex++) {
            let ruleAction: CurrentRuleAction = this.ruleActions[ruleIndex];

            // Is there an existing form field expression with this rule's first condition?
            let firstCondition: CurrentRuleCondition = ruleAction.conditions[0];
            let conditionOperator: ConditionalLogicRuleOperator = availableOperators.find(o => o.id == firstCondition.comparisonOperatorId);
            let existingRuleCopy: FormFieldExpression = existingRulesCopy.find(r => (r.sourceFieldName == firstCondition.sourceFormField.name) && (r.operatorSymbol == conditionOperator.symbol) && (r.operandValue == firstCondition.comparisonValue));
            if (existingRuleCopy != null) {
                existingRuleCopy.applyTargetFieldDefaultAttributesToActions(ruleAction.targetFieldDefaultAttributes);
                convertedRules.push(existingRuleCopy);
                existingRulesCopy = existingRulesCopy.filter(r => r != existingRuleCopy); // Don't use this expression more than once.
            }
            let additionalFormFieldExpressions: FormFieldExpression[] = ruleAction.copyToExistingRuleAndNewRulesAsNeeded(form, metadataFauxFormFields, existingRuleCopy, availableOperators, existingRulesCopy.length);

            for (let exprIndex: number = 0; exprIndex < additionalFormFieldExpressions.length; exprIndex++) {
                let convertedRule: FormFieldExpression = additionalFormFieldExpressions[exprIndex];
                convertedRule.applyTargetFieldDefaultAttributesToActions(ruleAction.targetFieldDefaultAttributes);
                convertedRules.push(convertedRule);
            }
        }

        // Finally, return the converted rule.
        return convertedRules;
    }

    public addAnyUsedMetadataFieldsNotYetInForm(form: Form, metadataFauxFormFields: FormField[]): number {
        let numMetadataFields: number = 0;

        // Are there any metadata fields used in expressions that are not yet part of the form?
        for (let exprIndex: number = 0; exprIndex < form.conditionalLogicRules.length; exprIndex++) {
            let expr: FormFieldExpression = form.conditionalLogicRules[exprIndex];
            if (expr.sourceFieldId < 0) {
                numMetadataFields++;

                let metadataFauxFormField: FormField = metadataFauxFormFields.find(ff => ff.id == expr.sourceFieldId);
                if (metadataFauxFormField == null)
                    throw `AllCurrentRuleActions.convertToFormFieldExpressions():  cannot find a metadata field with id value ${expr.sourceFieldId}.`;

                let existingFormField: FormField = form.formFields.find(ff => ff.fieldDefinitionClassName == metadataFauxFormField.fieldDefinitionClassName);
                if (existingFormField == null) {
                    let metadataFormField: FormField = new FormField();
                    metadataFormField.isMetadataField = true;
                    metadataFormField.id = 0; // Will save a new form field.
                    metadataFormField.name = metadataFauxFormField.fieldDefinitionClassName;
                    metadataFormField.displayName = metadataFauxFormField.displayName;
                    metadataFormField.fieldDefinitionClassName = metadataFauxFormField.fieldDefinitionClassName;
                    form.formFields.push(metadataFormField);
                }
            }
        }

        return numMetadataFields;
    }

    // Helper methods.
    private static doSortByTargetFieldAscending(ruleAction1: CurrentRuleAction, ruleAction2: CurrentRuleAction): number {
        let targetFormField1: FormField = ruleAction1.targetFormFields[0];
        let targetFormField2: FormField = ruleAction2.targetFormFields[0];
        //let targetField1Name: string = FormFieldUtil.getFieldName(ruleAction1.targetFormField);
        //let targetField2Name: string = FormFieldUtil.getFieldName(ruleAction2.targetFormField);
        let targetField1Name: string = FormFieldUtil.getFieldName(targetFormField1);
        let targetField2Name: string = FormFieldUtil.getFieldName(targetFormField2);

        let iCompare: number = targetField1Name.localeCompare(targetField2Name);

        return iCompare;
    }
    private doSortByTargetFieldAndActionPrecedence(ruleAction1: CurrentRuleAction, ruleAction2: CurrentRuleAction): number {
        let targetFormField1: FormField = ruleAction1.targetFormFields[0];
        let targetFormField2: FormField = ruleAction2.targetFormFields[0];
        //let targetField1Name: string = FormFieldUtil.getFieldName(ruleAction1.targetFormField);
        //let targetField2Name: string = FormFieldUtil.getFieldName(ruleAction2.targetFormField);
        let targetField1Name: string = FormFieldUtil.getFieldName(targetFormField1);
        let targetField2Name: string = FormFieldUtil.getFieldName(targetFormField2);

        let iCompare: number = targetField1Name.localeCompare(targetField2Name);

        if (iCompare == null)
            iCompare = this.fieldConditionalLogicService.compareFieldActions(ruleAction1.targetFieldAction, ruleAction2.targetFieldAction);

        return iCompare;
    }
}

export class AllFieldInfo {
    private formFields: FormField[] = null;
    private metadataFieldDefs: FieldDefinition[] = null;
    private metadataFauxFormFields: FormField[] = null;
    private allFieldsSorted: FormField[] = null;

    public constructor(formFields: FormField[], metadataFields: FieldDefinition[]) {
        // Note:  need to make sure we make array copies; otherwise, manipulating these arrays can modified the form's form fields.
        this.formFields = [];
        for (let index: number = 0; index < formFields.length; index++)
            this.formFields.push(formFields[index])
        this.metadataFieldDefs = [];
        for (let index: number = 0; index < metadataFields.length; index++)
            this.metadataFieldDefs.push(metadataFields[index]);
    }

    // Methods.
    public get AllFieldsSortedByNameAscending(): FormField[] {
        if (this.allFieldsSorted == null) {
            let fauxMetadataFields: FormField[] = this.metadataFieldsAsFauxFormFields();
            this.allFieldsSorted = this.formFields;
            for (let index: number = 0; index < fauxMetadataFields.length; index++) {
                let fauxMetadataField: FormField = fauxMetadataFields[index];
                let existingMetadataField: FormField = this.allFieldsSorted.find(ff => ff.fieldDefinitionClassName == fauxMetadataField.fieldDefinitionClassName);
                if (existingMetadataField == null)
                    this.allFieldsSorted.push(fauxMetadataField);
            }
            this.allFieldsSorted.sort(AllFieldInfo.doSortFieldsByNameAscending);
        }

        return this.allFieldsSorted;
    }

    public metadataFieldsAsFauxFormFields(): FormField[] {
        if (this.metadataFauxFormFields == null) {
            this.metadataFauxFormFields = [];
            let sortedFieldDefs: FieldDefinition[] = this.metadataFieldDefs.sort(AllFieldInfo.doSortFieldDefsByNameAscending);

            let fauxFormFieldId: number = -1;
            for (let index: number = 0; index < sortedFieldDefs.length; index++) {
                let metadataField: FieldDefinition = sortedFieldDefs[index];

                let fauxFormField: FormField = new FormField();
                fauxFormField.isMetadataField = true;
                fauxFormField.id = fauxFormFieldId--;
                fauxFormField.name = metadataField.fieldDefinitionClassName;
                fauxFormField.displayName = metadataField.displayName;
                fauxFormField.fieldDefinitionClassName = metadataField.fieldDefinitionClassName;

                this.metadataFauxFormFields.push(fauxFormField);
            }
        }

        return this.metadataFauxFormFields;
    }
    public metadataFauxFormFieldNames(): string[] {
        let fauxFormFields: FormField[] = this.metadataFieldsAsFauxFormFields();
        let fauxFormFieldNames: string[] = fauxFormFields.map(ff => ff.displayName);
        return fauxFormFieldNames;
    }

    // Helper methods.
    private static doSortFieldsByNameAscending(formField1: FormField, formField2: FormField): number {
        let fieldName1: string = FormFieldUtil.getFieldName(formField1);
        let fieldName2: string = FormFieldUtil.getFieldName(formField2);

        let iCompare: number = fieldName1.localeCompare(fieldName2);

        return iCompare;
    }

    private static doSortFieldDefsByNameAscending(fieldDef1: FieldDefinition, fieldDef2: FieldDefinition): number {
        let iCompare: number = fieldDef1.displayName.localeCompare(fieldDef2.displayName);
        return iCompare;
    }
}
